// Bundle promotion message functionality
document.addEventListener('DOMContentLoaded', function() {
  // Add event listeners to all add to cart buttons
  const addToCartButtons = document.querySelectorAll('.product-card--add-to-cart-button');
  
  addToCartButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      // Get the bundle message from the data attribute
      const bundleMessage = this.getAttribute('data-bundle-message');
      
      if (bundleMessage) {
        // Find the bundle promo message container (sibling of the button)
        const container = this.closest('.product-card--add-to-cart-button-container');
        const promoElement = container.querySelector('.product-card--bundle-promo');
        
        if (promoElement) {
          // Set the message text and show it
          promoElement.textContent = bundleMessage;
          promoElement.style.display = 'block';
          promoElement.style.opacity = '1';
          
          // Add a class to indicate it's been shown
          promoElement.classList.add('is-visible');
          
          // Fade out after 5 seconds
          setTimeout(function() {
            // Start the fade out animation
            promoElement.style.opacity = '0';
            
            // After the fade completes, hide the element
            setTimeout(function() {
              promoElement.style.display = 'none';
              promoElement.classList.remove('is-visible');
            }, 1000); // Match this to the CSS transition duration
          }, 5000);
        }
      }
    });
  });
});
